import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import * as theme from '../../theme';

export default function ThankYou() {
  return (
    <div style={{ ...theme.Container.basic, ...theme.Container.centeredViewport }}>
      <div style={theme.PaddedContainer}>
        <div style={{ ...theme.Heading, ...theme.Center, marginBottom: 30, fontSize: 36 }}>Thank You!</div>
        <div style={{ marginBottom: 26, textAlign: 'center', width: '100%' }}><ThumbUpAltIcon color={'primary'} sx={{ fontSize: 70 }} /></div>
        <div style={{ ...theme.SubHeading2, ...theme.Center }}>
          You are good to go for your scheduled scan! If you have any questions, please send them to your practitioner.
        </div>
      </div>
    </div>
  );
}